<div>
    <ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.numerical">
        <div
            class="opinion-numerical-type margin-bottom-3"
            role="radiogroup"
            [attr.aria-labelledby]="ariaLabelledBy"
            *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.numerical"
        >
            <div role="radio" *ngFor="let number of opinionScaleNumbers; let index = index">
                <div
                    [class]="
                        isSecondaryVariant
                            ? 'opinion-numerical-type-number-secondary-variant'
                            : 'opinion-numerical-type-number'
                    "
                >
                    <span>{{ number }}</span>
                </div>
                <div *ngIf="index === 0 && interviewQuestion.questionValues[0]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[0] }}
                </div>
                <div *ngIf="index === 2 && interviewQuestion.questionValues[1]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[1] }}
                </div>
                <div *ngIf="index === 4 && interviewQuestion.questionValues[2]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[2] }}
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.stars">
        <div
            *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.stars"
            class="opinion-stars-type margin-bottom-3"
            [class.opinion-stars-type-second-variant]="isSecondaryVariant"
        >
            <div *ngFor="let _ of opinionScaleStars; let index = index">
                <div class="opinion-scale-star-type">
                    <img src="/assets/icons/stars/star-default.svg" />
                </div>
                <div *ngIf="index === 0 && interviewQuestion.questionValues[0]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[0] }}
                </div>
                <div *ngIf="index === 2 && interviewQuestion.questionValues[1]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[1] }}
                </div>
                <div *ngIf="index === 4 && interviewQuestion.questionValues[2]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[2] }}
                </div>
            </div>
        </div>
    </ng-container>
</div>
